module.exports = __webpack_public_path__ + "static/media/mail.e9784b92.png";